import { IServices } from "@netent/origin";
import { ILeftHandModeState } from "@netent/playui";
import { FeatureStateCreator } from "../../types";

export const leftHandModeState: FeatureStateCreator<ILeftHandModeState> = (
  services: IServices
): ILeftHandModeState => ({
  value: services.gameSettings.getSetting("leftHandMode")
});
